import { useState } from "react";

import { t } from "../../i18n";
import { reloadForUpdate } from "../../lib/pwa";

/**
 * Shown when a newer build is waiting.
 *
 * Reloading is always safe here: every edit in this app saves on change, so
 * there is never unsaved work to lose. The banner exists so the reload is the
 * user's choice rather than a page that jumps underneath them.
 */
export function UpdateBanner() {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;

  return (
    <div className="updatebar" role="status">
      <span>{t("A new version of Roof Board is ready.")}</span>
      <button className="btn-primary" onClick={() => void reloadForUpdate()}>
        {t("Reload")}
      </button>
      <button className="btn-ghost" onClick={() => setDismissed(true)}>
        {t("Later")}
      </button>
    </div>
  );
}
